import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        primary: {
            main: '#DCD747',
        },
        secondary: {
            main: '#08B2E3',
        },
    },
});
